import { render } from "./ProductSelectTable.vue?vue&type=template&id=0fd8f125"
import script from "./ProductSelectTable.vue?vue&type=script&lang=js"
export * from "./ProductSelectTable.vue?vue&type=script&lang=js"

import "./ProductSelectTable.vue?vue&type=style&index=0&id=0fd8f125&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/h5/product/ProductSelectTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fd8f125"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fd8f125', __exports__)) {
    api.reload('0fd8f125', __exports__)
  }
  
  module.hot.accept("./ProductSelectTable.vue?vue&type=template&id=0fd8f125", () => {
    api.rerender('0fd8f125', render)
  })

}


export default __exports__